module.exports = __webpack_public_path__ + "img/7e1e4743b87a0c9b21301ce4e83841d4.png";